import gsap from "gsap";
import { DrawSVGPlugin, ScrollTrigger, ScrollSmoother } from "gsap/all";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

// Register Plugins
gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, ScrollSmoother);

export default class ScrollSmoothButter extends DefaultBlock {
	// Define variables
	init() {
		const selector = gsap.utils.selector(this.block);

		const DOM = {
			block: this.block,
			discs: selector(".scroll-smooth-butter__spiral-disc img"),
		};
		this.DOM = DOM;

		this.defaults = {
			ease: "power1.inOut",
			duration: 1,
		};

		this.tl = this.createTimeline();
	}

	createTimeline() {
		watchPreferredMotion(() => {
			const tl = gsap.timeline({
				defaults: this.defaults,
				scrollTrigger: {
					scrub: 1,
					trigger: this.DOM.block,
					start: "top bottom",
					end: "bottom top",
				},
			});

			const rotations = [180, -360, 270, -90, 540, -360, 180];

			tl.to(this.DOM.discs, {
				rotation: gsap.utils.wrap(rotations),
			});
		});
	}
}
